import { Typography } from '@mui/material';

import { AuthLayoutTemplate } from 'shared/ui/AuthLayoutTemplate';

export const UnapprovedUser = () => {
  return (
    <AuthLayoutTemplate pageName="UnapprovedUser">
      <div className="flex flex-col items-center gap-8">
        <div className="flex flex-col gap-2">
          <Typography variant="h1">Your account is under review</Typography>
          <Typography variant="body1">Truv will send you an email once your account is approved.</Typography>
        </div>
      </div>
    </AuthLayoutTemplate>
  );
};
